import wrapper from 'wrapper';
import Scroller from '../scrolly-library/scroller';
import events from '../scrolly-library/events-emitter';
/* eslint-disable no-console */

class Scrolly {
    constructor() {
        this.scrolly = new Scroller({
            step: '.step',
            graphic: '.scroll__graphic', // this class, and the ones below, are in the scrolly library so shouldn't need changing
            container: '.scroll__container',
            textContainer: '.scroll__text',
            offset: this.setOffset(),
            debug: false, // defaults to false
        });
        this.animated = wrapper.select('.animation-toggle').checked;
        this.scrollyImage = wrapper.select('.scrolly-image');
        this.hideElementsBySelector('.layout-box');
        this.revealElementsBySelector('.step--1');
        this.layoutBoxIsometric = wrapper.select('.layout-box--isometric');
        this.setIsometricPosition('centre', false);
        this.stepLastEntered = { element: wrapper.select('div.step'), index: 0, currentDirecton: 'down' };

        this.scrollyConfig = {
            scrollDown: [
                () => {
                    // scroll into Laila on the train
                    this.hideElementsBySelector('.step--1');
                    this.revealElementsBySelector('.step--2');
                },
                () => {
                    // scroll into "butterblock" building
                    this.hideElementsBySelector('.step--2');
                    this.revealElementsBySelector('.step--3');
                    this.setIsometricPosition('default', false);
                },
                () => {
                    // scroll into split layout - Ground floor detail/Thermal imaging
                    this.revealElementsBySelector('.isometric-ground-floor');
                    this.revealElementsBySelector('.layout-box--isometric');
                    this.hideElementsBySelector('.step--3');
                    this.revealElementsBySelector('.step--6');
                    this.revealElementsBySelector('.step--7');
                    this.revealElementsBySelector('.layout-box--main');
                    this.revealElementsBySelector('.mask');
                    wrapper.select('.isometric-ground-floor').classList.add('step--6');
                },
                () => {
                    // scroll into Ground floor detail/Facial recognition
                    wrapper.select('.isometric-ground-floor').classList.remove('step--6');
                    wrapper.select('.isometric-ground-floor').classList.add('step--8');
                    this.hideElementsBySelector('.layout-box--main .step--7');
                    this.revealElementsBySelector('.step--8');
                },
                () => {
                    // scroll into step Ground floor detail/Lifts
                    wrapper.select('.isometric-ground-floor').classList.remove('step--4');
                    wrapper.select('.isometric-ground-floor').classList.add('step--9');
                    this.hideElementsBySelector('.layout-box--main .step--8');
                    this.revealElementsBySelector('.lifts--b');
                },
                () => {
                    // scroll into step 10 (5C: All floors, animating/Laila in the lift)
                    this.hideElementsBySelector('.step--8');
                    this.hideElementsBySelector('.lifts--b');
                    this.hideElementsBySelector('.isometric-ground-floor');
                    wrapper.select('.layout-box--isometric .step--10').classList.add('lifts--going-up');
                    this.revealElementsBySelector('.step--10');
                },
                () => {
                    // scroll into 4th floor detail/corridor illustration
                    wrapper.select('.layout-box--isometric .step--10').classList.remove('lifts--going-down');
                    wrapper.select('.layout-box--isometric .step--10').classList.remove('lifts--going-up');
                    this.hideElementsBySelector('.lifts--c');
                    this.revealElementsBySelector('.corridor--b');
                    this.revealElementsBySelector('.step--12');
                },
                () => {
                    // scroll into 4th floor office, hand sanitiser highlighted/Hand sanitiser illustration
                    wrapper.select('.isometric-office').classList.remove('step--12');
                    wrapper.select('.isometric-office').classList.add('step--13');
                    this.hideElementsBySelector('.corridor--b');
                    this.revealElementsBySelector('.step--13');
                },
                () => {
                    // scroll into 4th floor office, desk highlighted/Laila at her desk
                    wrapper.select('.isometric-office').classList.remove('step--13');
                    wrapper.select('.isometric-office').classList.add('step--desk-area');
                    this.hideElementsBySelector('.step--13');
                    this.revealElementsBySelector('.step--14');
                },
                () => {
                    // scroll into 4th floor office, kitchen highlighted/Laila in the kitchen
                    wrapper.select('.isometric-office').classList.remove('step--desk-area');
                    wrapper.select('.isometric-office').classList.add('step--15');
                    this.hideElementsBySelector('.step--14');
                    this.revealElementsBySelector('.step--15');
                },
                () => {
                    // scroll into 4th floor office, air con animation
                    wrapper.select('.isometric-office').classList.remove('step--15');
                    wrapper.select('.isometric-office').classList.add('step--16');
                    this.hideElementsBySelector('.step--15');
                    this.revealElementsBySelector('.step--16');
                },
                () => {
                    // scroll into 4th floor office, partitions highlighted/Illustration with partitions
                    wrapper.select('.isometric-office').classList.add('step--partition');
                    wrapper.select('.isometric-office').classList.remove('step--16');
                    this.hideElementsBySelector('.step--16');
                    this.revealElementsBySelector('.step--17');
                },
                () => {
                    // scroll into 4th floor office, partitions highlighted/Illustration same but with plants
                    wrapper.select('.isometric-office').classList.remove('step--partition');
                    wrapper.select('.isometric-office').classList.add('step--plants');
                    this.hideElementsBySelector('.step--17');
                    this.revealElementsBySelector('.step--18');
                },
                () => {
                    // scroll into 4th floor office, breakout space highlighted/Breakout space illustration
                    wrapper.select('.isometric-office').classList.remove('step--plants');
                    wrapper.select('.isometric-office').classList.add('step--breakout-space');
                    this.hideElementsBySelector('.step--18');
                    this.revealElementsBySelector('.layout-box');
                    this.revealElementsBySelector('.step--19');
                },
                () => {
                    // scroll into Mono-layout - Laila on the night train
                    this.hideElementsBySelector('.mask');
                    this.hideElementsBySelector('.layout-box');
                    this.hideElementsBySelector('.step--19');
                    this.hideElementsBySelector('.isometric-floor-layers');
                    this.hideElementsBySelector('.isometric-office');
                    this.revealElementsBySelector('.step--20');
                },
                () => {
                    // scroll into house "butterblock" in city illustration
                    this.hideElementsBySelector('.step--20');
                    this.revealElementsBySelector('.step--21a');
                },
                () => {
                    // scroll into isolated house "butterblock" illustration
                    this.hideElementsBySelector('.step--21a');
                    this.revealElementsBySelector('.step--21b');
                },
                () => {
                    // scroll into House isometric
                    this.setIsometricPosition('centre', false);
                    this.hideElementsBySelector('.step--21b');
                    this.revealElementsBySelector('.layout-box--isometric');
                    this.revealElementsBySelector('.step--22');
                },
                () => {
                    // scroll into Split layout - House isometric/Laila at her desk / highlight desk
                    this.setIsometricPosition('default', true);
                    this.revealElementsBySelector('.mask');
                    this.revealElementsBySelector('.step--23');
                    this.revealElementsBySelector('.layout-box--main');
                    wrapper.select('.isometric-house-highlights').classList.add('step--house-desk');
                },
                () => {
                    // highlight windows?
                    wrapper.select('.isometric-house-highlights').classList.remove('step--house-desk');
                    wrapper.select('.isometric-house-highlights').classList.add('step--house-window');
                },
                () => {
                    // scroll into Split layout - House isometric with garden highlighted/Laila in the garden
                    this.hideElementsBySelector('.step--23');
                    this.revealElementsBySelector('.step--25');
                    wrapper.select('.isometric-house-highlights').classList.remove('step--house-window');
                    wrapper.select('.isometric-house-floors').classList.add('step--garden');
                },
            ],
            scrollUp: [
                // This does not have to be the same as the 'scroll down' steps - sometimes you may need to do the opposite, such as reverse an animation
                () => {
                    // scroll into Intro illustration of Laila
                    this.revealElementsBySelector('.step--1');
                    this.hideElementsBySelector('.step--2');
                },
                () => {
                    // scroll into Laila on the train
                    this.revealElementsBySelector('.step--2');
                    this.hideElementsBySelector('.step--3');
                    this.setIsometricPosition('default', false);
                },
                () => {
                    // scroll into "butterblock" building
                    this.hideElementsBySelector('.step--7');
                    this.hideElementsBySelector('.step--6');
                    this.revealElementsBySelector('.step--3');
                    this.hideElementsBySelector('.layout-box--main');
                    this.hideElementsBySelector('.mask');
                },
                // we dropped hidden steps 5/6
                () => {
                    // scroll into Split layout - Ground floor detail/Thermal imaging
                    wrapper.select('.isometric-ground-floor').classList.add('step--6');
                    wrapper.select('.isometric-ground-floor').classList.remove('step--8');
                    this.revealElementsBySelector('.layout-box--main .step--7');
                    this.hideElementsBySelector('.step--8');
                },
                () => {
                    // scroll into Ground floor detail/Facial recognition
                    wrapper.select('.isometric-ground-floor').classList.add('step--4');
                    wrapper.select('.isometric-ground-floor').classList.remove('step--9');
                    this.revealElementsBySelector('.layout-box--main .step--8');
                    this.hideElementsBySelector('.lifts--b');
                },
                () => {
                    // scroll into Ground floor detail/Lifts
                    wrapper.select('.layout-box--isometric .step--10').classList.remove('lifts--going-up');
                    wrapper.select('.layout-box--isometric .step--10').classList.remove('lifts--going-down');
                    this.revealElementsBySelector('.lifts--b');
                    this.revealElementsBySelector('.isometric-ground-floor');
                    this.hideElementsBySelector('.step--10');
                },
                () => {
                    // scroll into All floors, animating/Laila in the lift
                    wrapper.select('.layout-box--isometric .step--10').classList.add('lifts--going-down');
                    this.revealElementsBySelector('.lifts--c');
                    this.hideElementsBySelector('.corridor-b');
                    this.hideElementsBySelector('.step--12');
                },
                () => {
                    // scroll into 4th floor office detail, corridor highlighted/Laila in wider corridor
                    wrapper.select('.isometric-office').classList.add('step--12');
                    wrapper.select('.isometric-office').classList.remove('step--13');
                    this.revealElementsBySelector('.corridor--b');
                    this.hideElementsBySelector('.step--13');
                },
                () => {
                    // scroll into 4th floor office, hand sanitiser highlighted/Hand sanitiser illustration
                    wrapper.select('.isometric-office').classList.add('step--13');
                    wrapper.select('.isometric-office').classList.remove('step--desk-area');
                    this.revealElementsBySelector('.step--13');
                    this.hideElementsBySelector('.step--14');
                },
                () => {
                    // scroll into 4th floor office, desk highlighted/Laila at her desk
                    wrapper.select('.isometric-office').classList.remove('step--15');
                    wrapper.select('.isometric-office').classList.add('step--desk-area');
                    this.revealElementsBySelector('.step--14');
                    this.hideElementsBySelector('.step--15');
                },
                () => {
                    // scroll into 4th floor office, kitchen highlighted/Laila in the kitchen
                    wrapper.select('.isometric-office').classList.add('step--15');
                    wrapper.select('.isometric-office').classList.remove('step--16');
                    this.revealElementsBySelector('.step--15');
                    this.hideElementsBySelector('.step--16');
                },
                () => {
                    // scroll into 4th floor office, air con highlighted/Air con illustration or animation TBC)
                    wrapper.select('.isometric-office').classList.add('step--16');
                    wrapper.select('.isometric-office').classList.remove('step--partition');
                    this.revealElementsBySelector('.layout-box--main .step--16');
                    this.hideElementsBySelector('.layout-box--main .step--17');
                },
                () => {
                    // scroll into 4th floor office, partitions highlighted/Illustration with partitions highlighted)
                    wrapper.select('.isometric-office').classList.remove('step--plants');
                    wrapper.select('.isometric-office').classList.add('step--partition');
                    this.revealElementsBySelector('.layout-box--main .step--17');
                    this.hideElementsBySelector('.layout-box--main .step--18');
                },
                () => {
                    // scroll into 4th floor office, partitions highlighted/Illustration same but with plants highlighted)
                    wrapper.select('.isometric-office').classList.add('step--plants');
                    wrapper.select('.isometric-office').classList.remove('step--breakout-space');
                    this.revealElementsBySelector('.layout-box--main .step--18');
                    this.hideElementsBySelector('.layout-box--main .step--19');
                },
                () => {
                    // scroll into 4th floor office, breakout space highlighted/Breakout space illustration
                    this.revealElementsBySelector('.isometric-floor-layers');
                    this.revealElementsBySelector('.isometric-office');
                    this.revealElementsBySelector('.layout-box');
                    this.revealElementsBySelector('.step--19');
                    this.hideElementsBySelector('.step--20');
                    this.setIsometricPosition('default', false);
                    this.revealElementsBySelector('.mask');
                },
                () => {
                    // scroll into Mono-layout - Laila on the night train
                    this.revealElementsBySelector('.step--20');
                    this.hideElementsBySelector('.step--21a');
                    this.hideElementsBySelector('.layout-box');
                },
                () => {
                    // scroll into house "butterblock" in city illustration
                    this.hideElementsBySelector('.step--21b');
                    this.revealElementsBySelector('.step--21a');
                },
                () => {
                    // scroll into isolated house "butterblock" illustration
                    this.hideElementsBySelector('.step--22');
                    this.revealElementsBySelector('.step--21b');
                    this.hideElementsBySelector('.layout-box--isometric');
                },
                () => {
                    // scroll into House isometric
                    this.setIsometricPosition('centre', true);
                    this.hideElementsBySelector('.layout-box--main');
                    this.hideElementsBySelector('.step--23');
                    this.hideElementsBySelector('.step--25');
                    this.hideElementsBySelector('.mask');
                    wrapper.select('.isometric-house-highlights').classList.remove('step--house-desk');
                },
                () => {
                    // nothing changes?
                    wrapper.select('.isometric-house-highlights').classList.add('step--house-desk');
                    wrapper.select('.isometric-house-highlights').classList.remove('step--house-window');
                },
                () => {
                    // scroll into split layout - House isometric/Laila at her desk with desk, light, storage, chair highlighted) House isometric with bedroom office highlighted/Laila closing window)
                    this.revealElementsBySelector('.step--23');
                    this.hideElementsBySelector('.step--25');
                    wrapper.select('.isometric-house-floors').classList.remove('step--garden');
                    wrapper.select('.isometric-house-highlights').classList.add('step--house-window');
                },
            ],
        };

        // set up scroller events/callbacks
        events.on('step-enter', (interaction) => {
            this.handleStepEnter(interaction);
            this.stepLastEntered = interaction;
            wrapper.trackUserAction('scrolly step triggered', `step: ${interaction.index}, direction: ${interaction.currentDirection}`);
        });

        events.on('step-exit', (interaction) => {
            this.handleStepExit(interaction);
        });

        events.on('animation-toggled', (target) => {
            this.animated = target;
        });

        window.addEventListener('orientationchange', () => {
            // After orientationchange, add a one-time resize event - because orientation called before rotate has finished and dimensions updated
            const afterOrientationChange = () => {
                this.scrolly.offset = this.setOffset();
                this.scrolly.offsetVal = this.scrolly.setOffsetTrigger();
                this.scrolly.handleResize();
                this.handleStepEnter(this.stepLastEntered);
                window.removeEventListener('resize', afterOrientationChange);
            };
            window.addEventListener('resize', afterOrientationChange);
        });
    }

    setOffset() {
        return window.innerWidth < 700 ? 0.9 : 0.8;
    }

    handleStepEnter(interaction) {
        if (interaction.currentDirection === 'down' && interaction.index > 0) {
            this.scrollyConfig.scrollDown[interaction.index - 1]();
        }
        if (interaction.currentDirection === 'up' && interaction.index === this.scrollyConfig.scrollUp.length) {
            this.scrollyConfig.scrollUp[this.scrollyConfig.scrollUp.length - 1](); // trigger angie in her office on scroll back up (not correctly by the step exit handler)
        }
    }

    handleStepExit(interaction) {
        if (interaction.currentDirection === 'up' && interaction.index <= this.scrollyConfig.scrollUp.length) {
            if (interaction.index > 0) this.scrollyConfig.scrollUp[interaction.index - 1](); // temp fix to stop errors
        }
    }

    hideElementsBySelector(bo) {
        wrapper.selectAll(bo).forEach((element) => {
            element.classList.remove('visible');
        });
    }

    revealElementsBySelector(bo) {
        wrapper.selectAll(bo).forEach((element) => {
            element.classList.add('visible');
        });
    }

    setIsometricPosition(pos = 'default', animate = false) {
        const classToAdd = `position-isometric--${pos}`;
        const classToRemove = (pos === 'default' ? 'position-isometric--centre' : `position-isometric--default`);
        this.layoutBoxIsometric.classList.remove('animate');

        if (animate) {
            // this.layoutBoxIsometric = this.cancelAnimationsOnElt(this.layoutBoxIsometric);
            this.layoutBoxIsometric.classList.add('animate');
            this.layoutBoxIsometric.classList.remove(classToRemove);
            window.setTimeout(() => {
                this.layoutBoxIsometric.classList.add(classToAdd);
            }, 5);
        }
        else {
            this.layoutBoxIsometric.classList.remove(classToRemove);
            this.layoutBoxIsometric.classList.add(classToAdd);
        }
    }

    cancelAnimationsOnElt(elt) {
        const elementNode = elt;
        const containerElt = elementNode.parentNode;
        containerElt.removeChild(elementNode);
        containerElt.append(elementNode);
        return elementNode;
    }
}

export default Scrolly;
